import React from 'react';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from 'lucide-react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { Section } from '../components/ui/Section';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { companyInfo } from '../data/mock';

export const ContactPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <div className="bg-primary-dark py-24 text-center text-white mt-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Kontaktirajte Nas</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Tu smo da odgovorimo na sva vaša pitanja i pružimo najbolje rešenje.
          </p>
        </div>
      </div>

      <main className="flex-grow">
        <Section>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Contact Info */}
            <div className="lg:col-span-1 space-y-6">
              <Card className="p-8 border-none shadow-lg bg-primary text-white">
                <h3 className="text-2xl font-bold mb-6">Informacije</h3>
                <ul className="space-y-6">
                  <li className="flex items-start gap-4">
                    <div className="bg-white/20 p-3 rounded-lg">
                      <MapPin size={24} />
                    </div>
                    <div>
                      <p className="text-blue-200 text-sm mb-1">Adresa</p>
                      <p className="font-medium">{companyInfo.address}</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-4">
                    <div className="bg-white/20 p-3 rounded-lg">
                      <Phone size={24} />
                    </div>
                    <div>
                      <p className="text-blue-200 text-sm mb-1">Telefon</p>
                      <a href={`tel:${companyInfo.phone}`} className="font-medium hover:text-secondary transition-colors">
                        {companyInfo.phone}
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-4">
                    <div className="bg-white/20 p-3 rounded-lg">
                      <Mail size={24} />
                    </div>
                    <div>
                      <p className="text-blue-200 text-sm mb-1">Email</p>
                      <a href={`mailto:${companyInfo.email}`} className="font-medium hover:text-secondary transition-colors">
                        {companyInfo.email}
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-4">
                    <div className="bg-white/20 p-3 rounded-lg">
                      <Clock size={24} />
                    </div>
                    <div>
                      <p className="text-blue-200 text-sm mb-1">Radno Vreme</p>
                      <p className="font-medium">{companyInfo.workingHours}</p>
                    </div>
                  </li>
                </ul>

                <div className="mt-8 pt-8 border-t border-white/20 flex gap-4">
                  <a href={companyInfo.facebook} className="bg-white/20 p-3 rounded-lg hover:bg-white hover:text-primary transition-all">
                    <Facebook size={24} />
                  </a>
                  <a href={companyInfo.instagram} className="bg-white/20 p-3 rounded-lg hover:bg-white hover:text-primary transition-all">
                    <Instagram size={24} />
                  </a>
                </div>
              </Card>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-2">
              <Card className="p-8 h-full">
                <h3 className="text-2xl font-bold mb-6 text-gray-900">Pošaljite Poruku</h3>
                <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                      <label htmlFor="name" className="text-sm font-medium text-gray-700">Ime i Prezime</label>
                      <input 
                        type="text" 
                        id="name" 
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                        placeholder="Vaše ime"
                      />
                    </div>
                    <div className="space-y-2">
                      <label htmlFor="phone" className="text-sm font-medium text-gray-700">Telefon</label>
                      <input 
                        type="tel" 
                        id="phone" 
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                        placeholder="Vaš broj telefona"
                      />
                    </div>
                  </div>
                  
                  <div className="space-y-2">
                    <label htmlFor="email" className="text-sm font-medium text-gray-700">Email Adresa</label>
                    <input 
                      type="email" 
                      id="email" 
                      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                      placeholder="vas@email.com"
                    />
                  </div>

                  <div className="space-y-2">
                    <label htmlFor="message" className="text-sm font-medium text-gray-700">Poruka</label>
                    <textarea 
                      id="message" 
                      rows={6}
                      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all resize-none"
                      placeholder="Opišite šta vam je potrebno..."
                    ></textarea>
                  </div>

                  <Button size="lg" className="w-full md:w-auto">
                    Pošalji Poruku
                  </Button>
                </form>
              </Card>
            </div>
          </div>
        </Section>

        {/* Map */}
        <div className="h-[400px] w-full bg-gray-200">
          <iframe 
            src={companyInfo.mapUrl}
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title="Lokacija Stolarija Leskovac"
          ></iframe>
        </div>
      </main>

      <Footer />
    </div>
  );
};
